import React from "react";
import Button, { ButtonVariant } from "components/Button";
import { useAppContext } from "lib/state/TextProvider";
import { FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { EntryType } from "lib/models";

function WorkspaceNavigation() {
  const { state, setWorkspaceNavigation } = useAppContext();
  const paths = state.workspaceNavigation;
  const navigate = useNavigate();

  const handleOnPathClick = (uuid: string) => {
    const idx = state.workspaceNavigation.findIndex((x) => x.uuid == uuid);
    if (idx >= 0) {
      setWorkspaceNavigation(state.workspaceNavigation.splice(0, idx + 1));
    }
  };

  const handleOnRootClick = () => {
    navigate(`/`, { replace: true });
  };

  if (state.entry?.data.type !== EntryType.WORKSPACE) {
    return null;
  }
  if (state.entry.data.isRoot) {
    return null;
  }

  return (
    <div className="absolute w-fit top-2 left-2">
      <div className="flex flex-row items-center text-sm font-bold text-palette-3">
        <div className="inline-block box-border w-8 h-8">
          <FaHome
            className="w-full h-full px-2 rounded-md hover:bg-palette-5 hover:text-palette-2"
            onClick={handleOnRootClick}
          />
        </div>
        <div className="flex flex-row items-center">
          {paths.map(({ uuid, title }) => (
            <div
              key={`WorkspaceNavigation${uuid}`}
              className="flex flex-row items-center"
            >
              <div className="pr-1">/</div>
              <div
                className="rounded-md p-2 hover:bg-palette-5 hover:text-palette-2"
                onClick={() => handleOnPathClick(uuid)}
              >
                {title !== "null" ? title : "Unnamed Workspace"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WorkspaceNavigation;
